<script setup lang="ts">
import { onMounted } from 'vue'

import { useAdaPagestrip } from '../../composables/use-ada-pagestrip'
import ParagraphTypeAdaAdSlot from './AdaAdSlot.vue'

const props = withDefaults(defineProps<{ pagestripId?: string }>(), { pagestripId: '' })

const { pagestripMainId, initPagestrip } = useAdaPagestrip()

onMounted(() => {
  pagestripMainId.value = props.pagestripId
  initPagestrip()
})
</script>

<template>
  <ParagraphTypeAdaAdSlot slot-name="mobile"
                          :slot-id="1" />
  <div class="bx-content bx-ada-pagestrip-main">
    <div id="pagestrip-main" />
  </div>
</template>
